import { render, staticRenderFns } from "./NewBadge.vue?vue&type=template&id=6249bff0&scoped=true"
import script from "./NewBadge.vue?vue&type=script&lang=js"
export * from "./NewBadge.vue?vue&type=script&lang=js"
import style0 from "./NewBadge.vue?vue&type=style&index=0&id=6249bff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6249bff0",
  null
  
)

export default component.exports